import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=bcf1ee16&scoped=true&"
var script = {}
import style0 from "./Delete.vue?vue&type=style&index=0&id=bcf1ee16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1ee16",
  null
  
)

export default component.exports